export enum Skill {
  Lungs = "Lungs",
}
